/**
 * Campaign Order Summary frontend behavior.
 *
 * Keeps URL query arg in sync when items are removed.
 */
document.addEventListener( 'DOMContentLoaded', () => {
	const blocks = document.querySelectorAll( '.campaign-order-summary[data-cos-param]' );
	if ( ! blocks.length ) {
		return;
	}

	blocks.forEach( ( blockEl ) => {
		const param = blockEl.getAttribute( 'data-cos-param' ) || 'campaign-resources';
		const hiddenIdsInput = blockEl.querySelector( '[data-campaign-order-summary-ids]' );

		blockEl.addEventListener( 'click', ( event ) => {
			const removeButton = event.target.closest?.( '.campaign-order-summary__remove' );
			if ( ! removeButton ) {
				return;
			}

			const itemEl = removeButton.closest( '.campaign-order-summary__item' );
			if ( ! itemEl ) {
				return;
			}

			const removeId = itemEl.getAttribute( 'data-id' );
			if ( ! removeId ) {
				return;
			}

			const remaining = Array.from( blockEl.querySelectorAll( '.campaign-order-summary__item[data-id]' ) )
				.map( ( el ) => el.getAttribute( 'data-id' ) )
				.filter( ( id ) => id && id !== removeId );

			if ( hiddenIdsInput ) {
				hiddenIdsInput.value = remaining.join( ',' );
			}

			// phpcs:ignore WordPressVIPMinimum.JS.Window -- used only to build a URL for navigation, not output.
			const url = new URL( window.location.href );
			if ( remaining.length ) {
				url.searchParams.set( param, remaining.join( ',' ) );
			} else {
				url.searchParams.delete( param );
			}
			window.location.assign( url.toString() );
		} );
	} );
} );

